import { TRADE_PORTAL_URL, COUNTRY } from "../constants";

export type THandleLinkClick = (
    event: React.MouseEvent<HTMLAnchorElement, MouseEvent>,
    url: string,
    target?: string,
    isTradeLink?: boolean
) => void;

export const handleLinkClick: THandleLinkClick = (event, url, target = "_self", isTradeLink = false): void => {
  event.preventDefault();
  if (isTradeLink) {
    window.scrollTo({ top: 0, behavior: "smooth" });
    const nodeEnv: string = TRADE_PORTAL_URL as string;
    window.open(`${nodeEnv}${url}`, target);
  } else {
    window.open(url, target);
  }
};

export const convertCountryCode = (code: string) => {
  switch (code) {
    case "en":
      return "GB";
    case "ar":
      if (COUNTRY === "ae") {
        return "AE";
      }
      if (COUNTRY === "ly") {
        return "LY";
      }
      return "SA";
    case "bn":
      return "BD";
    default:
      return code;
  }
};

export type TShowTitleWithDots = (
    e: React.MouseEvent<HTMLElement> | React.UIEvent<HTMLElement>,
    value: string,
    basedOnHeight?: boolean
) => void;

export const showTitleWithDots: TShowTitleWithDots = (
    e,
    value,
    basedOnHeight = true
): void => {
  let childSize: number, itemSize: number;

  if (basedOnHeight) {
    childSize = (e.currentTarget.childNodes[0] as HTMLElement).offsetHeight;
    itemSize = e.currentTarget.offsetHeight;
  } else {
    childSize = (e.currentTarget.childNodes[0] as HTMLElement).offsetWidth;
    itemSize = e.currentTarget.offsetWidth;
  }

  if (childSize > itemSize) {
    (e.target as HTMLElement).title = value;
  } else {
    (e.target as HTMLElement).title = "";
  }
};

export const localeToCode = (locale:string) => {
  if (!locale) {
    return "";
  }
  return locale.split("_")[0];
};
